import * as d3 from 'd3';
import * as _ from 'lodash';

import { LineSeries } from '../..';

export interface ReturnFormatValue {
    x: Date;
    y: number;
    y0: number;
    originalValue: number | null | undefined;
    originalData: any;
    hide: boolean;
}

export interface ReturnFormat {
    id: any;
    values: ReturnFormatValue[];
    s: LineSeries;
}

const handlePostiveAndNegative = (dataSeriesCount: number) => {
    let currentXOffsets = [];
    let currentXIndex = 0;
    return function (d, y0, y) {
        if (currentXIndex++ % dataSeriesCount === 0) {
            currentXOffsets = [0, 0];
        }
        if (y >= 0) {
            d.y0 = currentXOffsets[1];
            d.y = y;
            currentXOffsets[1] += y;
        } else {
            d.y0 = currentXOffsets[0] + y;
            d.y = -y;
            currentXOffsets[0] += y;
        }
    };
};

const getLayout = (seriesCount: number) => {
    return d3.layout.stack<any, any>()
        .out(handlePostiveAndNegative(seriesCount))
        .values((d: any) => d.values);
};

function buildReturnFormatValue(
    d: string,
    s: LineSeries,
    dataDates: any[],
    data: any[]
): ReturnFormatValue {
    let originalValue: number = null;
    let value: number = 0;
    let originalData = {};
    let hide = false;

    const index = dataDates.indexOf(d);
    if (index >= 0) {
        const fromData = data[index];
        originalValue = s.value(fromData);
        if (originalValue !== null) {
            value = originalValue || 0;
            originalData = fromData;
        }
    } else {
        hide = true;
    }

    return {
        x: new Date(d),
        y: value,
        y0: undefined,
        originalValue,
        originalData,
        hide
    };
}

export function mapStackedSeries(series: LineSeries[], dates: string[]): ReturnFormat[] {
    // reorder dates to prevent spaghetti lines
    dates = _.sortBy(dates, d => d);

    // stacked series
    const stackedSeries: ReturnFormat[] = series
        .map(s => {
            const data = s.data();
            const dataDates = data.map(d => d.timeStamp.toISOString ? d.timeStamp.toISOString() : d.timeStamp);
            return {
                id: s.identifier(),
                values: dates
                    .map(d => buildReturnFormatValue(d, s, dataDates, data))
                    .filter(rfv => rfv.originalData !== undefined),
                s
            };
        });
    const ready = getLayout(stackedSeries.length)(stackedSeries);
    return ready;
}